import { Button, IconButton } from '../forms';

import { DefaultCardType } from '../../types';
import { FaQuestion } from 'react-icons/fa';
import { FunctionComponent } from 'react';
import { IconHandler } from '../../utils';
import { t } from 'i18next';

const DefaultCard: FunctionComponent<DefaultCardType> = ({
  cardTitle,
  cardSubtitle = null,
  cardIcon = null,
  headerClassName = '',
  headerAction,
  helpLink,
  noBodyMargin = false,
  children,
  footer,
  empty = false,
  emptyMessage,
  emptyIcon,
  mainActionButton,
  mainActionName,
  mainAction,
  mainActionIcon,
  mainActionDisabled = false,
  singleCardPage = false,
}) => {
  return (
    <div className="col card responsive-spacing">
      <div className="card-content">
        <div
          className={`card-header bg-transparent d-flex flex-row justify-content-between align-items-start px-3 pb-2 pt-3 ${headerClassName}`}
        >
          <div className={`d-flex justify-content-start align-items-center mb-lg-0`}>
            {cardIcon && (
              <div className={'card-icon'}>
                <IconHandler Icon={cardIcon} size={'2rem'} />
              </div>
            )}
            <div className="px-2">
              <h2 className="fs-5 my-0">{cardTitle}</h2>
              {{ cardSubtitle } && <div className="text-muted lh-sm">{cardSubtitle}</div>}
            </div>
          </div>
          {(headerAction || mainAction || mainActionButton || helpLink) && (
            <div className={`d-flex justify-content-end gap-2`}>
              {headerAction}

              {!empty &&
                (mainActionButton
                  ? mainActionButton
                  : mainActionIcon
                    ? mainAction && (
                        <IconButton
                          Icon={mainActionIcon}
                          title={mainActionName!}
                          onClick={mainAction}
                          disabled={mainActionDisabled}
                        />
                      )
                    : mainAction && <Button title={mainActionName!} onClick={mainAction} disabled={mainActionDisabled} />)}

              {helpLink && (
                <IconButton
                  Icon={FaQuestion}
                  title={t('label.ajuda')}
                  onClick={() => {
                    window.open(helpLink, '_blank');
                  }}
                  className={''}
                  circle
                />
              )}
            </div>
          )}
        </div>
        <div className={`card-body responsive-spacing pt-2 ${footer ? `pb-2` : `pb-4`} ${noBodyMargin ? 'px-0' : ''}`}>
          {empty ? (
            <div
              className={`empty-body-card ${
                singleCardPage ? 'single-card' : ''
              } d-flex flex-column align-items-center justify-content-center`}
            >
              {emptyIcon && <IconHandler Icon={emptyIcon} className={''} />}
              <div className={'text-muted text-center'}>{emptyMessage}</div>
              {mainActionButton ? (
                <>{mainActionButton}</>
              ) : (
                mainAction && <Button title={mainActionName!} onClick={mainAction} disabled={mainActionDisabled} />
              )}
            </div>
          ) : (
            <>{children}</>
          )}
        </div>
        {footer && !empty && <div className="card-footer bg-transparent p-3 pt-2">{footer}</div>}
      </div>
    </div>
  );
};

export default DefaultCard;
